const objectAssignDeep = require('object-assign-deep');

export default ({ Vue }) => {
  Vue.$copy = objectAssignDeep.noMutate;
  Vue.prototype.$copy = objectAssignDeep.noMutate;
};



// WEBPACK FOOTER //
// ./src/plugins/copy.js